import { EntrepriseBase } from 'src/app/data/intervenant/models/entreprise-base.model';
import { ClassConverterFactory } from '../../../../core/services/mapper/data-property.converter';

export class EngagementSc {
    static jsonMap = {
        id: { key: 'id', optional: true },
        entreprise: { key: 'entreprise', converter: new (ClassConverterFactory.build(EntrepriseBase))(), optional: true },
        utilisationLogo: { key: 'utilisationLogo' },
        certificationBrc: { key: 'certificationBrc' },
        certificationIfs: { key: 'certificationIfs' }
    };

    public id: number = undefined;
    public entreprise: EntrepriseBase = undefined;
    public utilisationLogo: boolean = undefined;
    public certificationBrc: boolean = undefined;
    public certificationIfs: boolean = undefined;
}
